import { ReactNode } from 'react';
import { Flex } from 'reflexbox';
import styled from 'styled-components';

import { tokens } from '../theme/tokens';
import { FlexGap } from './FlexGap';
import { Paragraph } from './Text';

const ICON_SIZE = 16;

const Container = styled(Flex)`
	width: 100%;
	background-image: ${(props) => props.theme.images.lineGradient};
	color: ${tokens.text.white};
	text-align: center;

	${Paragraph} {
		color: ${tokens.text.white};
	}
`;

const IconSlot = styled.div`
	flex-shrink: 0;
	width: ${ICON_SIZE}px;
	height: ${ICON_SIZE}px;
	color: inherit;

	svg {
		display: block;
		width: ${ICON_SIZE}px;
		height: ${ICON_SIZE}px;
		color: inherit;
	}
`;

const Side = styled(Flex)`
	flex: 1 1 0;
	min-width: 0;
	align-items: center;
`;

export function StatusBar(props: { text?: ReactNode | string; icon?: ReactNode; end?: ReactNode }) {
	return (
		<Container
			px={`${tokens.padding.container}px`}
			py={`${tokens.padding.compact}px`}
			alignItems="center"
		>
			<Side />
			<FlexGap alignItems="center" justifyContent="center" gap={tokens.gap.element}>
				{props.icon && <IconSlot>{props.icon}</IconSlot>}
				<Paragraph>{props.text}</Paragraph>
			</FlexGap>
			<Side justifyContent="flex-end">{props.end}</Side>
		</Container>
	);
}
